export default "__VITE_ASSET__E8H5WSpF__"